const nlCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Naam your file...",
    description: "Placeholder for file name input",
  },
};

export default nlCreateFile;
